import React from "react";
import "./BarChartComponent.css";
import Chart from "react-apexcharts";
import Table_section from "./Table_section/Table_section";

const BarChartComponent = ({ yearlyBreakdown }) => {
  // const options = {
  //   series: [
  //     {
  //       name: "Income",
  //       type: "column",
  //       data: [1.4, 2, 2.5, 1.5, 2.5, 2.8, 3.8, 4.6],
  //     },
  //     {
  //       name: "Cashflow",
  //       type: "column",
  //       data: [1.1, 3, 3.1, 4, 4.1, 4.9, 6.5, 8.5],
  //     },
  //     {
  //       name: "Revenue",
  //       type: "line",
  //       data: [20, 29, 37, 36, 44, 45, 50, 58],
  //     },
  //   ],
  //   chart: {
  //     height: 350,
  //     type: "line",
  //     stacked: false,
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   stroke: {
  //     width: [1, 1, 4],
  //   },
  //   title: {
  //     text: "XYZ - Stock Analysis (2009 - 2016)",
  //     align: "left",
  //     offsetX: 110,
  //   },
  //   xaxis: {
  //     categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016],
  //   },
  //   yaxis: [
  //     {
  //       seriesName: "Income",
  //       axisTicks: { show: true },
  //       axisBorder: { show: true, color: "#008FFB" },
  //       labels: { style: { colors: "#008FFB" } },
  //       title: {
  //         text: "Income (thousand crores)",
  //         style: { color: "#008FFB" },
  //       },
  //       tooltip: { enabled: true },
  //     },
  //     {
  //       seriesName: "Cashflow",
  //       opposite: true,
  //       axisTicks: { show: true },
  //       axisBorder: { show: true, color: "#00E396" },
  //       labels: { style: { colors: "#00E396" } },
  //       title: {
  //         text: "Operating Cashflow (thousand crores)",
  //         style: { color: "#00E396" },
  //       },
  //     },
  //     {
  //       seriesName: "Revenue",
  //       opposite: true,
  //       axisTicks: { show: true },
  //       axisBorder: { show: true, color: "#FEB019" },
  //       labels: { style: { colors: "#FEB019" } },
  //       title: {
  //         text: "Revenue (thousand crores)",
  //         style: { color: "#FEB019" },
  //       },
  //     },
  //   ],
  //   tooltip: {
  //     fixed: {
  //       enabled: true,
  //       position: "topLeft",
  //       offsetY: 30,
  //       offsetX: 60,
  //     },
  //   },
  //   legend: {
  //     horizontalAlign: "left",
  //     offsetX: 40,
  //   },
  // };

  // const options = {
  //   series: [
  //     {
  //       name: "Principal Paid",
  //       type: "column",
  //       data: yearlyBreakdown.map((data) => data.principalPaid),
  //     },
  //     {
  //       name: "Interest Paid",
  //       type: "column",
  //       data: yearlyBreakdown.map((data) => data.interestPaid),
  //     },
  //     {
  //       name: "Total Amount Paid",
  //       type: "line",
  //       data: yearlyBreakdown.map((data) => data.totalPaid),
  //     },
  //   ],
  //   chart: { height: 350, type: "line", stacked: false },
  //   xaxis: { categories: yearlyBreakdown.map((data) => data.year) },
  //   yaxis: [
  //     {
  //       title: { text: "Amount Paid (₹)" },
  //     },
  //   ],
  // };

  const years = yearlyBreakdown?.map((item) => item.year);
  const principalPaid = yearlyBreakdown?.map((item) => item.principalPaid);
  const interestPaid = yearlyBreakdown?.map((item) => item.interestPaid);
  const totalPaid = yearlyBreakdown?.map((item) => item.totalPaid);
  const remainingBalance = yearlyBreakdown?.map((item) => item.remainingBalance);
  const percentagePaid = yearlyBreakdown?.map((item) => item.percentagePaid);

  const options = {
    series: [
      {
        name: "Principal Paid",
        type: "column",
        data: principalPaid,
      },
      {
        name: "Interest Paid",
        type: "column",
        data: interestPaid,
      },
      // {
      //   name: "Total Payment",
      //   type: "line",
      //   data: totalPaid,
      // },
      // {
      //   name: "Loan Paid To Date",
      //   type: "line",
      //   data: percentagePaid,
      // },
      {
        name: "Balance",
        type: "line",
        data: remainingBalance,
      },
    ],
    chart: {
      height: 350,
      type: "line",
      stacked: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [0, 0, 3], // Thicker line for remaining balance
      curve: "smooth", // Smooth mid-line
    },
    title: {
      text: "Loan Payment Breakdown",
      align: "left",
      offsetX: 110,
    },
    xaxis: {
      categories: years,
      title: { text: "Year" },
    },
    
    yaxis: [
      {
        seriesName: "Principal Paid",
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#008FFB" },
        labels: { style: { colors: "#008FFB" } },
        title: {
          text: "Principal Paid (₹)",
          style: { color: "#008FFB" },
        },
      },
      {
        seriesName: "Interest Paid",
        opposite: true,
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#00E396" },
        labels: { style: { colors: "#00E396" } },
        title: {
          text: "Interest Paid (₹)",
          style: { color: "#00E396" },
        },
      },
      {
        seriesName: "Total Payment",
        opposite: true,
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#FEB019" },
        labels: { style: { colors: "#FEB019" } },
        title: {
          text: "Total Payment (₹)",
          style: { color: "#FEB019" },
        },
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: "topLeft",
        offsetY: 30,
        offsetX: 60,
      },
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
    },
  };

  return (
    <section className="BarChartComponent">
      <div className="bar_char_div">
        <Chart
          options={options}
          series={options.series}
          type="line"
          height={350}
        />
      </div>
      <Table_section yearlyBreakdown={yearlyBreakdown}/>
    </section>
  );
};

export default BarChartComponent;
